<template lang="pug">
  include ../mixins
  div
    slot(:profileLink="profileLink")
      +b.A.i-link.--size_3xs(
        v-if='isAuthenticated'
        :href="profileLink"
        :class="{ 'i-link--color_white': color === 'white', 'i-link--color_accent-1': color === 'accent' }"
      )
        +e.icon.--size_2sm
          +b.I.ls-icon.--type_user-2
        +e.SPAN.text {{ _('Мой профиль') }}
      modal-handler(
        v-else
        component-name="auth-login-modal"
        :objectItem="{ needRedirect: true }"
        modal-class="modal-common modal--size_sm modal--full-container"
      )
        template(#default="{ handler }")
          +b.i-link.--size_3xs(
            @click.prevent="handler"
            :class="{ 'i-link--color_white': color === 'white', 'i-link--color_accent-1': color === 'accent' }"
          )
            +e.icon.--size_2sm
              +b.I.ls-icon.--type_user-2
            +e.SPAN.text {{ _('Мой профиль') }}
</template>

<script>
import { mapState } from 'vuex'
import { REDIRECTS } from '@md/users/permissions'

export default {
  props: {
    color: {
      type: String,
      default: 'accent',
    },
  },

  computed: {
    ...mapState('users/auth', [
      'user',
    ]),

    profileLink() {
      return this.$router.resolve({ name: REDIRECTS[this.user.info.typeUser] }).href
    },
  },

  data() {
    return {
      isAuthenticated: window.isAuthenticated,
    }
  },
}
</script>
